module.exports = __webpack_public_path__ + "static/media/a2.7f84770.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/songyimin/a2.mp3
// module id = j/il
// module chunks = 0